import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

// @ts-expect-error - imported from .js/.jsx file
import {LightbulbDimIcon} from 'shells/icon/svg/lightbulb-dim-icon';

import {analyticsClient} from '../../analytics-client';
import type {NutshellState} from '../../store';

import {useGetMcfxViqContacts} from './graphql/hooks/use-get-mcfx-viq-contacts';
import {openSidebar} from './redux/actions';
import * as selectors from './redux/selectors';

import styles from './people-iq-badge.module.css';

type Props = {
    accountId: string;
    accountName: string;
    leadId?: string;
};

export function PeopleIqBadge(props: Props) {
    const [isDuplicateIndicatorPresent, setIsDuplicateIndicatorPresent] = React.useState(false);
    const hasDismissed = useSelector((state: NutshellState) =>
        selectors.getHasDismissedForAccount(state, props.accountId)
    );

    const dispatch = useDispatch();
    const {mcfxViqContacts: contacts} = useGetMcfxViqContacts(props.accountId);

    const onOpenSidebar = (e: React.SyntheticEvent<any>) => {
        e.preventDefault();
        e.stopPropagation();

        if (props.leadId) {
            analyticsClient.track(analyticsClient.EVENTS.TRACK_PIQ_SIDEBAR_LEAD_OPENED);
        } else {
            analyticsClient.track(analyticsClient.EVENTS.TRACK_PIQ_SIDEBAR_ACCOUNT_OPENED);
        }

        dispatch(
            openSidebar({
                accountId: props.accountId,
                accountName: props.accountName,
                leadId: props.leadId,
                contacts: contacts || [],
            })
        );
    };

    // hack to check all duplicates on the page to see if our badge needs to move left to avoid overlap
    const checkForDuplicates = () => {
        // Only check for duplicates if on a lead page
        if (props.leadId) {
            document.querySelectorAll('.state-duplicate').forEach((el) => {
                const duplicateEntityId = el.getAttribute('data-entity-id');
                if (duplicateEntityId && duplicateEntityId === props.accountId.split('-')[0]) {
                    setIsDuplicateIndicatorPresent(true);
                }
            });
        }
    };

    React.useEffect(() => {
        // check for duplicates on mount
        checkForDuplicates();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        // listen for duplicate detection events
        $('body').on(Nut.events.card.duplicateWasDetected, checkForDuplicates);

        return () => {
            $('body').off(Nut.events.card.duplicateWasDetected, checkForDuplicates);
        };
    });

    const style = isDuplicateIndicatorPresent
        ? {right: '156px', top: props.leadId ? '2px' : 0}
        : {top: props.leadId ? '2px' : 0};

    if (!hasDismissed && contacts && contacts.length > 0) {
        return (
            <div
                id='people-iq-badge'
                style={style}
                onClick={onOpenSidebar}
                className={styles.badge}
            >
                <div className='mr-4'>
                    <LightbulbDimIcon size={16} alignCenter={true} />
                </div>
                {contacts.length} {contacts.length === 1 ? 'person' : 'people'} found
            </div>
        );
    }

    return <></>;
}
